<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
     <validation-observer ref="observer" v-slot="{ handleSubmit }">
    <b-form @submit.stop.prevent="handleSubmit(generar)">
             <b-row>
        <b-col class="subtitulos ml-2">
        TRANSACCIONES MULTIVA
        </b-col>
      </b-row>
          <b-row class="mb-4">
            <b-col>
              <b-row>
                <b-col cols="4">
                  <validation-provider name="fcInicioVal" :rules="{ required: true }" v-slot="validationContext">
                    <label>Fecha de inicio:<validacion/></label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-datepicker placeholder="Fecha inicio"
                                        :max="new Date()"
                                        @input="fechaMaxima($event)"
                      ></b-form-datepicker>
                    </b-input-group>
                    <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                  </validation-provider>
                </b-col>

                <b-col cols="4">
                  <validation-provider name="fcFinVal" :rules="{ required: true }" v-slot="validationContext">
                    <label>Fecha de fin:<validacion/></label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-datepicker placeholder="Fecha fin"
                                          v-model="filtro.fechaFin"
                                         :max="fechaInicioAux.addDays(diasMaximoMes) > new Date() ? new Date(): fechaInicioAux.addDays(diasMaximoMes)"
                                         :min="fechaInicioAux"
                      ></b-form-datepicker>
                    </b-input-group>
                    <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                  </validation-provider>
                </b-col>
                      <b-col class="text-right col-2 mt-4">
                  <b-button
                      variant="outline-primary"
                      :disabled="loader"
                      @click="obtenerDatos()"
                  >
                    <span v-if="!loader">Buscar</span>
                    <span v-else>
                  <b-spinner small></b-spinner>
                  Buscando...
                </span>
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-form>
        </validation-observer>
               <b-col cols="12">
        <download-excel
            v-if="datosTabla.length > 0 && $localStorageService.can('Rep_trans_multiva_excel')"
            class="btn btn-primary"
            :data="datosTabla"
            :fields="fieldsExcel"
            worksheet="GestionVentas"
            name="Reporte de Transacciones Multiva.xls"
        >
          Generar Excel
          <em class="fa fa-file-excel-o"></em>
        </download-excel>
      </b-col>
          <b-row>
        <b-col cols="12">
          <b-table
            thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="$registrosPorPaginaTabla"
              :current-page="paginaActual"
              responsive
              class="parrafos"
          >
          <template v-slot:cell(respuesta)="row">
             <b-badge variant="success" v-if="row.item.respuesta === 'approved'">{{row.item.respuesta}}</b-badge>
             <b-badge variant="danger" v-else>{{row.item.respuesta}}</b-badge>
          </template>
         <template v-slot:cell(Pacientes)="row">
                <b-button size="sm" @click="row.toggleDetails">
                  {{ row.detailsShowing ? "Ocultar" : "Ver más" }}
                </b-button>
          </template>
        <template #row-details="row">
        <b-card>
          <span v-if="row.item.pacientes !== null">
               <ul v-for="item in row.item.pacientes" :key="item.nombre">
                   <li><strong>Nombre:</strong>{{item.nombre}}  <strong>Plan:</strong>{{item.plan}}</li>
               </ul>
          </span>
          <span v-else>
             <b-alert show variant="warning">No hay Pacientes</b-alert>
          </span>
        </b-card>
      </template>
          </b-table>
         <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla!==undefined && datosTabla.length === 0" variant="warning" show>No hay datos
            </b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="$registrosPorPaginaTabla"
                aria-controls="tabla"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>
        </div>
</template>

<script>
export default {
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
    datosTabla: [],
      fields: [],
      registrosPorPagina: 10,
      paginaActual: 0,
      loader: false,
      filtro: {
        fechaInicio: new Date(),
        fechaFin: null
      },
      hoy: new Date(),
      diasMaximoMes: null,
      fieldsExcel: {
        "Referencia Multiva": "idReferencia",
        "Emisor": "emisor",
        "MARCA DE TARJETA":"marcaTarjeta",
        "CODIGO DE RESPUESTA": "codigoRespueta",
        "RESPUESTA": "respuesta",
        "CODIGO DE ERROR": "codigoRespuetaError",
        "RESPUESTA DE ERROR":"respuestaError",
        "NUMERO AUTORIZACION": "numeroAutorizacion"
      },
      fechaInicioAux: new Date() 
    }
    },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
    mounted() {
    this.fields = [
      {key: "idReferencia", label: "REFERENCIA MULTIVA", sortable: true},
      {key: "emisor", label: "EMISOR", sortable: true},
      {key: "marcaTarjeta", label: "MARCA DE TARJETA", sortable: true},
      {key: "codigoRespueta", label: "CODIGO DE RESPUESTA", sortable: true},
      {key: "respuesta", label: "RESPUESTA", sortable: true},
      {key: "codigoRespuetaError", label: "CODIGO DE ERROR", sortable: true},
      {key: "respuestaError", label: "RESPUESTA DE ERROR", sortable: true},
      {key: "numeroAutorizacion", label: "NUMERO AUTORIZACION", sortable: true},
      "Pacientes",
    ];
  },
  methods:{
      obtenerDatos() {
      let fechaActual = this.$moment(this.filtro.fechaInicio).format("YYYY-MM-DD");
        let fechaF = this.$moment(this.filtro.fechaFin).format("YYYY-MM-DD");
      this.loader = true;
      this.datosTabla = [];
      const filtro = {
          "fechaInicio": fechaActual,
          "fechaFin": fechaF,
          "horas": this.$horas()
        };
        this.$http
            .post(this.$api +'reportes/transacciones/multiva', filtro)
            .then(respuesta => {
              if (respuesta.data.data) {
                if (respuesta.data.data !== undefined) {
                  this.datosTabla = respuesta.data.data;
                }
              }
            }).finally(() => {
          this.loader = false;
          this.paginaActual = 0;
        })
    },
    fechaMaxima(event){
     this.diasMaximoMes = this.$moment(event).daysInMonth();
      this.fechaInicioAux = new Date(event);
      this.filtro.fechaInicio = event;
      this.filtro.fechaFin = null;
      
    },
  }
}
</script>

<style>

</style>



